import { Component } from '@angular/core';

@Component({
  selector: 'app-no-regions',
  standalone: true,
  imports: [],
  templateUrl: './no-regions.component.html',
  styleUrls: ['./no-regions.component.scss', '../unauthorized.component.scss'],
})
export class NoRegionsComponent {}
